import Bouncer from 'approot/shared/bouncer/bouncer';
import { PStyled } from 'approot/shared/styles/typography.style';
import { FileDropperEditLoadingContainerStyled } from './file-dropper.style';

type Props = {
  loading?: boolean;
  file?: File;
  fileName?: string | null;
};

const FileDropperLoading = ({ loading = false, file, fileName }: Props) => {
  return (
    <FileDropperEditLoadingContainerStyled>
      {loading && !file && <PStyled>Getting the image...</PStyled>}
      {loading && file && <PStyled>Uploading {fileName}...</PStyled>}
      {!loading && <PStyled>One moment...</PStyled>}
      <Bouncer />
    </FileDropperEditLoadingContainerStyled>
  );
};

export default FileDropperLoading;
